import style from './InstructionsSkeleton.css';
import Skeleton from '../Skeleton/Skeleton';
import ArrayUtils from '../../../utils/array.utils';
import TopUpAppBar from '../../Wallet/TopUpAppBar/TopUpAppBar';

const ListItem = () => {
  return (
    <div className={style.item}>
      <Skeleton width="40px" height="40px" radius="50%" />
      <div className={style.text}>
        <Skeleton
          className={style['text-line']}
          width="80%"
          height="16px"
          radius="16px"
        />
        <Skeleton
          className={style['text-line']}
          width="45%"
          height="12px"
          radius="12px"
        />
      </div>
    </div>
  );
};
export default function InstructionsSkeleton({ className = '', items = 3 }) {
  return (
    <>
      <TopUpAppBar />

      <div className={style.container}>
        <main className={style.main}>
          <Skeleton width="160px" height="160px" radius="50%" />

          <div className={style.title}>
            <Skeleton
              className={style['title-line']}
              width="283px"
              height="24px"
              radius="30px"
            />
            <Skeleton
              className={style['title-line']}
              width="165px"
              height="16px"
              radius="16px"
            />
          </div>

          <div className={style.items}>
            {ArrayUtils.range(items).map(el => (
              <ListItem key={el} />
            ))}
          </div>
        </main>
      </div>
    </>
  );
}
